import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { NzMessageService } from 'ng-zorro-antd/message';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '../models/user.model';
import { UserDataService } from './user/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private user: Observable<User | null>;
  get user$(): Observable<User | null> {
    return this.user;
  }

  constructor(
    private auth: AngularFireAuth,
    private db: AngularFirestore,
    private message: NzMessageService,
    private userDataService: UserDataService
  ) {
    this.user = (this.auth.user as any).pipe(
      map((user: any) => {
        if (user == null) {
          return null;
        }
        return { id: user.uid };
      })
    );
  }

  async login(email: string, password: string): Promise<Observable<any | null>> {
    // TODO check email verification
    const user = await this.userDataService.getUserByEmail(email);
    if(user != null && Number(user.login_error_count) >= 3) {
      this.userDataService.updateLoginErrorCount(user.id, Number(user.login_error_count) + 1);
      this.message.error( 'このアカウントはロックされています。' );
      return from('');
    } else {
      return from(
        this.auth
          .signInWithEmailAndPassword(email, password)
          .then((credential) => {
            this.message.remove();
            this.userDataService.updateLoginErrorCount(user.id, 0);
            return credential.user != null ? { id: credential.user.uid } : null;
          })
          .catch((error) => {
            this.userDataService.updateLoginErrorCount(user.id, Number(user.login_error_count) + 1);
            if(Number(user.login_error_count) + 1 > 3) {
              this.message.error( 'このアカウントはロックされています。' );
            } else {
              this.message.error( 'IDまたはパスワードが間違っています。 再度確認してください。' );
            }
          })
      );
    }
  }

  isRoleAdmin() {
    let role = localStorage.getItem('role')?.toString();
    return role === '1' ? true : false;
  }

  isRoleAdminAgency() {
    let role = localStorage.getItem('role')?.toString();
    return role === '1' || role === '3' ? true : false;
  }

  isLogin() {
    let role = localStorage.getItem('role')?.toString();
    return role === '1' || role === '2' || role === '3' ? true : false;
  }
}
